// ----------------------------------------------------------------------------
// Section: FAQs
// ----------------------------------------------------------------------------
//
// FAQs Section
// - Based on the Accordion pattern
//
// ----------------------------------------------------------------------------

// -------------------------------------
// Dependencies
// -------------------------------------

// Scripts
import 'snippets/_containers/accordion/accordion';

// Styles
import './_faqs.scss';

// -------------------------------------
// Variables
// -------------------------------------
var SECTION_SELECTOR = '.featured-ingredients';
var ACCORDION_BUTTON = '.js-accordion__button';
var INGREDIENT_IMAGE = '.js-ingredient__image';

// Constant trigger classes
var OPEN_CLASS = 'is-open';
var DESKTOP_BREAKPOINT = 768;
function lockContentHeight(section) {
  var wrapper = section.querySelector('.featured-ingredients__content');
  if (!wrapper) return;
  wrapper.style.height = '';
  if (window.innerWidth < DESKTOP_BREAKPOINT) return;
  var panels = [...section.querySelectorAll('.js-accordion__content')];
  if (!panels.length) return;
  var snapshots = panels.map(el => ({
    hidden: el.hidden,
    height: el.style.height,
    classes: [...el.classList]
  }));
  panels.forEach(el => {
    el.hidden = true;
    el.style.height = '0';
    el.classList.remove(OPEN_CLASS);
  });
  var tallest = 0;
  panels.forEach(el => {
    el.hidden = false;
    el.style.height = 'auto';
    el.classList.add(OPEN_CLASS);
    tallest = Math.max(tallest, wrapper.scrollHeight);
    el.hidden = true;
    el.style.height = '0';
    el.classList.remove(OPEN_CLASS);
  });
  panels.forEach((el, i) => {
    el.hidden = snapshots[i].hidden;
    el.style.height = snapshots[i].height;
    el.className = snapshots[i].classes.join(' ');
  });
  if (tallest) wrapper.style.height = tallest + 'px';
}
function updateIngredientImages(section, index) {
  var images = section.querySelectorAll(INGREDIENT_IMAGE);
  var button = section.querySelectorAll(ACCORDION_BUTTON)[index];
  var target = section.querySelector("".concat(INGREDIENT_IMAGE, ".ingredient__").concat(index + 1));
  images.forEach(img => img.classList.remove(OPEN_CLASS));
  if (button.classList.contains(OPEN_CLASS) && target) {
    target.classList.add(OPEN_CLASS);
  }
}
document.querySelectorAll(SECTION_SELECTOR).forEach(section => {
  lockContentHeight(section);
  section.querySelectorAll(ACCORDION_BUTTON).forEach((button, i) => {
    var onToggle = () => requestAnimationFrame(() => updateIngredientImages(section, i));
    button.addEventListener('click', onToggle);
    button.addEventListener('keydown', e => {
      if (e.key === 'Enter' || e.key === ' ') onToggle();
    });
  });
});